import React from "react";

export const updatePopoverTriggerWidth = (event: React.SyntheticEvent<HTMLElement>): void => {
  document.documentElement.style.setProperty(
    "--evidence-select-trigger-width",
    `${event.currentTarget.offsetWidth}px`,
  );
};
